import React from 'react';

/**
 * Connecting status icon component
 * Displays audio equalizer bars to indicate connection/loading state
 */
const ConnectingIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="14" 
    height="12" 
    viewBox="0 0 14 12" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M1.31641 5L1.31641 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M5.10547 1L5.10547 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8.89453 4L8.89453 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12.6836 2L12.6836 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default ConnectingIcon;
